import store from "../store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"; // esto es para la base de datos
import "firebase/storage"; // esto es para el storage
import router from "../routes";
import apiServices from "@/services/yungol-services";

// siete produccion
const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

export default {
  install: (Vue, options) => {
    firebase.initializeApp(config);
    const auth = firebase.auth();
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithEmailAndPassword(username, pass);
      },
      loginGoogle: async () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithPopup(provider);
      },
      logout: async () => {
        await auth.signOut();
        store.commit("restartStore");
      },
      sendPasswordResetEmail: async (email) => {
        await auth.sendPasswordResetEmail(email, {
          url: process.env.FIREBASE_URL_EMAIL,
        });
      },
      createuser: (email, password) => {
        return auth.createUserWithEmailAndPassword(email, password);
      },
    };
    Vue.prototype.$fire = {
      // Company
      getImgCompany: (id) => {
        return firebase
          .storage()
          .ref(`images/companies/img_${id}`)
          .getDownloadURL();
      },
      saveImgCompany: (file, id) => {
        if (file && id) {
          return firebase
            .storage()
            .ref(`images/companies/img_${id}`)
            .put(file);
        }
      },
      deleteImgCompany: (path) => {
        return firebase
          .storage()
          .ref(path)
          .delete();
      },
      // Attached
      getAttached: (process) => {
        return firebase
          .storage()
          .ref(`attached/${process}`)
          .list({ maxResults: 50 });
      },
      saveAttached: (file, process) => {
        if (file && process) {
          const fileName = file.name;

          return firebase
            .storage()
            .ref(`attached/${process}/` + new Date().getTime() + "-" + fileName)
            .put(file, {
              contentDisposition: `attachment; filename="${fileName}"`,
            });
        }
      },
      deleteAttached: (path) => {
        return firebase
          .storage()
          .ref(path)
          .delete();
      },
      deleteFolderAttached: (process) => {
        const folder = firebase.storage().ref(`attached/${process}`);
        folder
          .listAll()
          .then((result) => {
            result.items.forEach((item) => {
              item
                .delete()
                .then(() => {
                  // console.log('Archivo eliminado con éxito.');
                })
                .catch((error) => {
                  console.error("Error al eliminar el archivo:", error);
                });
            });
          })
          .catch((error) => {
            console.error(
              `Error al listar archivos en la carpeta ${process}:`,
              error,
            );
            return false;
          });

        return true;
      },
      // Temp
      tempFiles: (file) => {
        return firebase
          .storage()
          .ref(`temp/${Date.now()}_${file.name}`)
          .put(file);
      },
      // General
      putimg: (file) => {
        return firebase
          .storage()
          .ref("images/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reffile: (file) => {
        return firebase
          .storage()
          .ref("files/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      refexcel: (file) => {
        return firebase
          .storage()
          .ref("excel/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
      reflideres: (file) => {
        return firebase
          .storage()
          .ref("lideres/" + new Date().getTime() + "-" + file.name)
          .put(file);
      },
    };
    auth.onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem("loggedin", "true");
        store.commit("refreshUser", user);
        store.commit("refreshAuth");
        user.getIdToken().then(
          (idtoken) => {
            store.commit("decodeToken", idtoken);
            if (
              store.state.tokenUser.admin ||
              store.state.tokenUser.cliente ||
              store.state.tokenUser.frs ||
              store.state.tokenUser.lider ||
              store.state.tokenUser.liderl ||
              store.state.tokenUser.ghumana ||
              store.state.tokenUser.free
            ) {
              store.commit("refreshAuth");
              apiServices
                .get(`/empresacredential`, {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                  },
                })
                .then((empresa) => {
                  store.commit("refreshEmpresa", empresa.data);
                });
            } else {
              localStorage.removeItem("loggedin");
              store.commit("restartStore");
              router.replace({
                name: "logout",
              });
            }
          },
          (error) => {
            store.commit("restartStore");
            console.log(error);
          },
        );
      } else {
        localStorage.removeItem("loggedin");
        store.commit("restartStore");
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/firebase/index.js